/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { VERB_ORGANIZE_REORDER } from "constants/enums";
import * as stores from "stores";
import { providers } from "dc-core";
import { handleReorderPages } from "./utils/OrganizeUtils";

class OrganizeReorderBootstrap extends Component {
  id = VERB_ORGANIZE_REORDER;

  initializeAction = () => {};

  _isValidParams = opts => opts.pageIndices && opts.pageIndices.length > 0 && opts.afterPageIndex !== undefined;

  executeAction = async (opts = {}) => {
    const editProvider = await providers["edit-provider"]();
    await editProvider?.loadEditModule();
    if (this._isValidParams(opts)) {
      await handleReorderPages(stores, opts.pageIndices, opts.afterPageIndex);
    }
  };

  render() {
    return null;
  }
}

export default OrganizeReorderBootstrap;
